import LocaleStrings from "Languages";
import { DEVELOPMENT_TYPE } from "Constants";

export default function () {
  return DEVELOPMENT_TYPE === "koachify"
    ? []
    : [
        {
          title: LocaleStrings.accountsetting_submenu_title1,
          iconName: "billings",
          description: LocaleStrings.accountsetting_submenu_description1,
        },
        {
          title: LocaleStrings.accountsetting_submenu_title2,
          iconName: "usagehistory",
          description: LocaleStrings.accountsetting_submenu_description2,
        },
        {
          title: LocaleStrings.accountsetting_submenu_title3,
          iconName: "reportissue",
          description: LocaleStrings.accountsetting_submenu_description3,
        },
        {
          title: LocaleStrings.setting_submenu_title3,
          iconName: "appstore",
          description: LocaleStrings.setting_submenu_description3,
        },
        {
          title: LocaleStrings.setting_submenu_title1,
          iconName: "passwordsetting",
          description: LocaleStrings.setting_submenu_description1,
        },
      ];
}
